import Input from './Input'

import './style.scss'

export { Input }
export default Input
